import type { QueryClient } from "@tanstack/react-query";

/**
 * Çalışma alanına BAĞLI sorgu anahtarı konvansiyonu (CLOS-80 `[043]`).
 *
 * ### Neden bir konvansiyon gerekiyor
 *
 * Alan değiştirmek, önceki alanın verisini ekrandan ve bellekten kaldırmak demek. Kart
 * açık: *"eski alana ait hassas veri görünmez."* Ama `queryClient.clear()` KULLANILAMAZ —
 * o oturum sorgusunu da siler ve geçiş, kullanıcıya çıkış yapılmış gibi görünür; kartın
 * ilk kriteri de tam olarak bunu yasaklıyor (*"geçiş oturumu kapatmaz"*).
 *
 * Seçici silme ancak tenant'lı sorguların tanınabilmesiyle mümkün. Bu yüzden hepsi
 * `["t", <tenantId>, ...]` biçiminde anahtarlanıyor: ön ek, "bu veri o alana aittir"
 * bilgisini anahtarın kendisine yazıyor.
 *
 * ### Neden bugün ölçülebilir bir sorun
 *
 * `setActiveTenant` cache'e hiç dokunmuyordu ve `staleTime` 30 saniye. Yani geçişten
 * sonra 30 saniye boyunca önceki alanın verisi ekranda kalıyordu. Bugün `/app` altında
 * neredeyse veri yok, o yüzden görünmüyor; sözleşme ekranları geldiğinde bu doğrudan
 * tenant sızıntısı olurdu.
 *
 * ### Kural
 *
 * Tenant'a bağlı HER sorgu `tenantKey` ile anahtarlanır. Hesap düzeyi sorgular
 * (`["session"]`, `["memberships"]`, profil) bu ön eki ALMAZ — onlar alan değişince
 * silinmemeli.
 */
export const TENANT_KEY_PREFIX = "t";

export function tenantKey(tenantId: string, ...parts: ReadonlyArray<string | number>) {
  return [TENANT_KEY_PREFIX, tenantId, ...parts] as const;
}

/**
 * Önceki alanın bütün verisini bellekten atar.
 *
 * `removeQueries` (invalidate değil): invalidate eski veriyi bayat işaretler ama BELLEKTE
 * ve ekranda bırakır — yeniden çekilene kadar kullanıcı hâlâ eski alanın verisini görür.
 * Geçişte istenen şey tazeleme değil, silme.
 */
export function clearTenantQueries(queryClient: QueryClient): void {
  queryClient.removeQueries({
    predicate: (query) => query.queryKey[0] === TENANT_KEY_PREFIX,
  });
}
